import { render, staticRenderFns } from "./NoBankAlert.vue?vue&type=template&id=70f94e48&scoped=true"
import script from "./NoBankAlert.vue?vue&type=script&lang=js"
export * from "./NoBankAlert.vue?vue&type=script&lang=js"
import style0 from "./NoBankAlert.vue?vue&type=style&index=0&id=70f94e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f94e48",
  null
  
)

export default component.exports